import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { formatNumber } from '@angular/common';
import { utc } from 'moment';
import { momentDateFormat, momentDateTimeFormat } from '../../../../models/date-formats';
import { StripHtmlPipe } from '../../../../pages/order-exceptions/pipes/strip-html.pipe';
import { TableColumn } from '../utils-table/utils-table.component';

@Component({
  selector: 'app-table-value-formatter',
  standalone: true,
  templateUrl: './table-value-formatter.component.html',
  imports: [StripHtmlPipe],
  styleUrl: './table-value-formatter.component.scss'
})
export class TableValueFormatterComponent {
  @Input() value: any;
  @Input() column: TableColumn | null = null;

  readonly noValue = '--';

  constructor(private sanitizer: DomSanitizer) {}

  transformNumber(): string {
    if (this.value === null || this.value === 'undefined') {
      return this.noValue;
    }
    return formatNumber(this.value, 'de-DE');
  }

  transformDateTime(date?: string): string {
    const utcDate = utc(date ? date : this.value);
    if (!utcDate.isValid()) {
      return this.noValue;
    }
    const isMidnight = utcDate.hours() === 0 && utcDate.minutes() === 0;
    return utcDate.format(isMidnight ? momentDateFormat : momentDateTimeFormat);
  }

  transformTextArray(): string {
    return Array.isArray(this.value) ? this.value.filter(Boolean).join(', ') : this.value || this.noValue;
  }

  transformChangeRecord(): SafeHtml {
    const htmlContent = this.value
      ? `<div style="text-decoration: line-through">${this.transformDateTime(this.value.oldValue)}</div>
         <div>${this.transformDateTime(this.value.currentValue)}</div>`
      : this.noValue;
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }

  transformDate() {
    const utcDate = utc(this.value);
    if (!utcDate.isValid()) {
      return this.noValue;
    }
    return utcDate.format(momentDateFormat);
  }
}
